/**
 * Okręgi Rumunii (județe) i regiony rozwoju, do prognozy produkcji w wersji /ro/.
 *
 * Użytkownik zna swój okręg, a nie region rozwoju, więc wybiera okręg; prognoza
 * bierze uzysk regionu (pvgisRumunia.js). To odpowiednik województw w Polsce, tylko
 * bez mapy: 42 pozycje mieszczą się na zwykłej liście rozwijanej.
 */

export const REGIONY_RO = [
  { key: 'nord_vest', nazwa: 'Nord-Vest' },
  { key: 'centru', nazwa: 'Centru' },
  { key: 'nord_est', nazwa: 'Nord-Est' },
  { key: 'sud_est', nazwa: 'Sud-Est' },
  { key: 'sud_muntenia', nazwa: 'Sud-Muntenia' },
  { key: 'bucuresti_ilfov', nazwa: 'București-Ilfov' },
  { key: 'sud_vest_oltenia', nazwa: 'Sud-Vest Oltenia' },
  { key: 'vest', nazwa: 'Vest' },
]

export const REGION_DOMYSLNY_RO = 'bucuresti_ilfov'

// Klucz okręgu jest zarazem tym, co zapisujemy w danych projektu (`wojewodztwo`),
// więc musi się różnić od kluczy województw: prefiks `ro_`.
export const OKREGI_RO = [
  { key: 'ro_alba', nazwa: 'Alba', region: 'centru' },
  { key: 'ro_arad', nazwa: 'Arad', region: 'vest' },
  { key: 'ro_arges', nazwa: 'Argeș', region: 'sud_muntenia' },
  { key: 'ro_bacau', nazwa: 'Bacău', region: 'nord_est' },
  { key: 'ro_bihor', nazwa: 'Bihor', region: 'nord_vest' },
  { key: 'ro_bistrita_nasaud', nazwa: 'Bistrița-Năsăud', region: 'nord_vest' },
  { key: 'ro_botosani', nazwa: 'Botoșani', region: 'nord_est' },
  { key: 'ro_braila', nazwa: 'Brăila', region: 'sud_est' },
  { key: 'ro_brasov', nazwa: 'Brașov', region: 'centru' },
  { key: 'ro_bucuresti', nazwa: 'București', region: 'bucuresti_ilfov' },
  { key: 'ro_buzau', nazwa: 'Buzău', region: 'sud_est' },
  { key: 'ro_calarasi', nazwa: 'Călărași', region: 'sud_muntenia' },
  { key: 'ro_caras_severin', nazwa: 'Caraș-Severin', region: 'vest' },
  { key: 'ro_cluj', nazwa: 'Cluj', region: 'nord_vest' },
  { key: 'ro_constanta', nazwa: 'Constanța', region: 'sud_est' },
  { key: 'ro_covasna', nazwa: 'Covasna', region: 'centru' },
  { key: 'ro_dambovita', nazwa: 'Dâmbovița', region: 'sud_muntenia' },
  { key: 'ro_dolj', nazwa: 'Dolj', region: 'sud_vest_oltenia' },
  { key: 'ro_galati', nazwa: 'Galați', region: 'sud_est' },
  { key: 'ro_giurgiu', nazwa: 'Giurgiu', region: 'sud_muntenia' },
  { key: 'ro_gorj', nazwa: 'Gorj', region: 'sud_vest_oltenia' },
  { key: 'ro_harghita', nazwa: 'Harghita', region: 'centru' },
  { key: 'ro_hunedoara', nazwa: 'Hunedoara', region: 'vest' },
  { key: 'ro_ialomita', nazwa: 'Ialomița', region: 'sud_muntenia' },
  { key: 'ro_iasi', nazwa: 'Iași', region: 'nord_est' },
  { key: 'ro_ilfov', nazwa: 'Ilfov', region: 'bucuresti_ilfov' },
  { key: 'ro_maramures', nazwa: 'Maramureș', region: 'nord_vest' },
  { key: 'ro_mehedinti', nazwa: 'Mehedinți', region: 'sud_vest_oltenia' },
  { key: 'ro_mures', nazwa: 'Mureș', region: 'centru' },
  { key: 'ro_neamt', nazwa: 'Neamț', region: 'nord_est' },
  { key: 'ro_olt', nazwa: 'Olt', region: 'sud_vest_oltenia' },
  { key: 'ro_prahova', nazwa: 'Prahova', region: 'sud_muntenia' },
  { key: 'ro_salaj', nazwa: 'Sălaj', region: 'nord_vest' },
  { key: 'ro_satu_mare', nazwa: 'Satu Mare', region: 'nord_vest' },
  { key: 'ro_sibiu', nazwa: 'Sibiu', region: 'centru' },
  { key: 'ro_suceava', nazwa: 'Suceava', region: 'nord_est' },
  { key: 'ro_teleorman', nazwa: 'Teleorman', region: 'sud_muntenia' },
  { key: 'ro_timis', nazwa: 'Timiș', region: 'vest' },
  { key: 'ro_tulcea', nazwa: 'Tulcea', region: 'sud_est' },
  { key: 'ro_valcea', nazwa: 'Vâlcea', region: 'sud_vest_oltenia' },
  { key: 'ro_vaslui', nazwa: 'Vaslui', region: 'nord_est' },
  { key: 'ro_vrancea', nazwa: 'Vrancea', region: 'sud_est' },
]

export const okregRo = (klucz) => OKREGI_RO.find((o) => o.key === klucz) || null

/** Region rozwoju dla okręgu; nieznany klucz (np. polskie województwo) daje region domyślny. */
export const regionOkregu = (klucz) => okregRo(klucz)?.region || REGION_DOMYSLNY_RO
